/**
 * `kind: 'text'`. `maxLength` is the spec's, so it matches what core enforces.
 * `request.mine` (the echo) exists only if the ask set `revealSubmittedToSelf`.
 */

import { useEffect, useRef, useState } from 'react';
import type { InputSpec } from '@gsf/contract';
import type { RendererProps } from '../renderer';

export function TextInput({
  request,
  spec,
  submit,
  disabled,
}: RendererProps<Extract<InputSpec, { kind: 'text' }>>) {
  const submitted = typeof request.mine?.value === 'string' ? request.mine.value : null;
  const [text, setText] = useState(submitted ?? '');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <>
      {request.prompt ? <p className="play-clue">{request.prompt}</p> : null}
      <form
        className="play-answer-form"
        onSubmit={(event) => {
          event.preventDefault();
          if (text.trim()) submit(text.trim());
        }}
      >
        <input
          ref={inputRef}
          value={text}
          onChange={(event) => setText(event.target.value)}
          placeholder={spec.placeholder ?? 'Your answer'}
          maxLength={spec.maxLength}
          autoComplete="off"
          disabled={disabled}
        />
        <button
          className="btn btn-primary btn-lg"
          type="submit"
          disabled={disabled || !text.trim()}
        >
          {submitted ? 'Update answer' : 'Submit'}
        </button>
        {submitted ? (
          <p className="faint">
            Submitted: “{submitted}”{request.allowRevision ? ' — you can change it.' : ''}
          </p>
        ) : null}
      </form>
    </>
  );
}
